import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import Toolbar from 'material-ui-next/Toolbar'
import IconButton from 'material-ui-next/IconButton'
import withStyles from 'material-ui-next/styles/withStyles'
import Divider from 'material-ui-next/Divider'
import Icon from 'material-ui-next/Icon'
import Menu, { MenuItem } from 'material-ui-next/Menu'
import MenuDivider from './MenuDivider'
import { ListItemIcon, ListItemText } from 'material-ui-next/List'
import Badge from 'material-ui-next/Badge'
import { uiExpandTopBar, uiCollapseTopBar, logout } from '../../actions'
import { getTopBarConfig } from '../../selectors'
import Search from './Search'
import { fade } from 'material-ui-next/styles/colorManipulator'

const SHRINK_THRESHOLD = 100

const styles = theme => ({
  toolbar: {
    backgroundColor: theme.swapick.colors.positive,
    color: theme.swapick.colors.light,
    minHeight: `${theme.swapick.dimensions.toolbar}px`,
    justifyContent: 'flex-start',
    transition: '0.5s',
    alignItems: 'flex-start',
    backgroundImage: 'url(/img/banda.jpg)',
    paddingLeft: '24px',
  },
  toolbarExpanded: {
    minHeight: `${theme.swapick.dimensions.toolbarExpanded}px`,
  },
  linkLogo: {
    alignSelf: 'center',
  },
  logo: {
    height: '40px',
    transition: '0.5s',
    'transition-timing-function': 'ease-out',
  },
  logoExpanded: {
    height: '150px',
  },
  iconButtonLink: {
    color: theme.swapick.colors.light,
    '&:hover': {
      color: theme.swapick.colors.light,
    },
    '&:visited': {
      color: theme.swapick.colors.light,
    },
    '&:active': {
      color: theme.swapick.colors.light,
    },
    '&:link': {
      color: theme.swapick.colors.light,
    },
  },
  primaryText: {
    color: theme.swapick.colors.positive,
    fontSize: 16,
  },
  menuText: {
    fontSize: 16,
  },
  leftLink: {
    paddingRight: '16px',
    color: 'rgb(229, 247, 248)!important',
    fontSize: 13,
    letterSpacing: '0.8px',
    fontWeight: 'lighter',
    fontFamily: 'Roboto, sans-serif',
  },
  leftLinkDivider: {
    alignSelf: 'center',
    marginLeft: 16,
  },
  searchContainer: {
    display: 'inline-flex',
    marginLeft: 20,
    alignItems: 'center',
    height: theme.swapick.dimensions.toolbar,
  },
  rightLinkContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'flex-end',
    height: theme.swapick.dimensions.toolbar,
    alignItems: 'center',
  },
  loginLinkContainer: {
    paddingLeft: 16,
    paddingTop: 2,
  },
  wrapper: {
    height: 32,
    width: 280,
    marginLeft: 16,
    position: 'relative',
    borderRadius: 2,
    background: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      background: fade(theme.palette.common.white, 0.25),
    },
    // '& $input': {
    //   transition: theme.transitions.create('width'),
    //   width: 200,
    //   '&:focus': {
    //     width: 250,
    //   },
    // },
  },
  inputSearch: {
    font: 'inherit',
    padding: 0,
    paddingLeft: 8,
    paddingRight: 35,
    border: 0,
    display: 'block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    margin: 0, // Reset for Safari
    color: theme.swapick.colors.white,
    width: '100%',
    '&:focus': {
      outline: 0,
    },
  },
  whiteIcon: {
    color: theme.swapick.colors.white,
    fontSize: '20px',
  },
  inFlexAlignCenter: {
    display: 'inline-flex',
    alignItems: 'center',
  },
})

const badgeStyles = theme => ({
  badge: {
    margin: '0px',
  },
  innerBadge: {
    backgroundColor: theme.swapick.colors.secondary,
    top: '-8px',
    right: '-7px',
    width: '18px',
    height: '18px',
  },
  rootBadge: {
    display: 'inline-flex',
  },
})

let NotificationBadge = ({ count, classes }) =>
  count ? (
    <Badge
      className={classes.badge}
      classes={{ badge: classes.innerBadge, root: classes.rootBadge }}
      badgeContent={count}>
      <Icon>notifications</Icon>
    </Badge>
  ) : (
    <Icon>notifications</Icon>
  )
NotificationBadge = withStyles(badgeStyles)(
  connect(state => ({
    count: state.loggedUserCounts.counts.newSwaps,
  }))(NotificationBadge)
)

class MainToolbarDesktop extends PureComponent {
  state = {
    menuOpen: false,
    anchorEl: null,
  }

  componentDidMount() {
    if (this.props.expandable) {
      window.addEventListener('scroll', this.resizeBar, false)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.expandable !== nextProps.expandable) {
      if (nextProps.expandable) {
        window.addEventListener('scroll', this.resizeBar, false)
        this.resizeBar()
      } else {
        window.removeEventListener('scroll', this.resizeBar)
      }
    }
  }

  componentWillUnmount() {
    if (this.props.expandable) {
      window.removeEventListener('scroll', this.resizeBar)
    }
  }

  resizeBar = () => {
    const { expanded } = this.props
    const top =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop

    if (top > SHRINK_THRESHOLD && expanded) {
      this.props.uiCollapseTopBar()
    } else if (top < SHRINK_THRESHOLD && !expanded) {
      this.props.uiExpandTopBar()
    }
  }

  isExpanded = () => {
    if (!this.props.expandable) {
      return false
    }
    return this.props.expanded
  }

  closeMenu = () => this.setState({ menuOpen: false, anchorEl: null })

  openMenu = e => this.setState({ menuOpen: true, anchorEl: e.currentTarget })

  render() {
    const { classes, logout, showAuthControls, user, topSearch } = this.props
    const expanded = this.isExpanded()
    const pointerClass = user ? '' : 'no-pointer-events'

    return (
      <Toolbar
        className={`${classes.toolbar} ${
          expanded ? classes.toolbarExpanded : ''
        }`}
        disableGutters={true}>
        <Link to="/" className={classes.linkLogo}>
          <img
            alt="Swapick Logo"
            src="/img/logo.png"
            className={`${classes.logo} ${
              expanded ? classes.logoExpanded : ''
            }`}
          />
        </Link>
        {topSearch && (
          <div className={classes.searchContainer}>
            <Search
              disableUnderline
              className={classes.wrapper}
              inputClassName={classes.inputSearch}
              iconClasses={{ icon: classes.whiteIcon }}
            />
          </div>
        )}

        <div className={classes.rightLinkContainer}>
          <Link 
            to="https://about.swapick.com/come-funziona"
            className={classes.leftLink} 
            target="_blank"
          >
            Come funziona
          </Link>
          <MenuDivider />
          {!showAuthControls && (
            <div className={classes.loginLinkContainer}>
              <Link to="/login" className={classes.leftLink}>
                Login
              </Link>
            </div>
          )}
          {showAuthControls && (
            <div className={classes.inFlexAlignCenter}>
              <IconButton
                className={`${classes.iconButtonLink} ${pointerClass}`}
                component={Link}
                to="/messages">
                <Icon>messages</Icon>
              </IconButton>
              <MenuDivider />
              <IconButton
                className={`${classes.iconButtonLink} ${pointerClass}`}
                component={Link}
                to="/notifications">
                <NotificationBadge />
              </IconButton>
              <MenuDivider />
              <IconButton
                className={`${classes.iconButtonLink} ${pointerClass}`}
                component={Link}
                to="/add">
                <Icon>control_point</Icon>
              </IconButton>
              <MenuDivider />
              <IconButton
                className={`${classes.iconButtonLink} ${pointerClass}`}
                onClick={this.openMenu}>
                <Icon>account_circle</Icon>
              </IconButton>
              <Menu
                id="account-menu"
                className={pointerClass}
                open={this.state.menuOpen}
                anchorEl={this.state.anchorEl}
                onClose={this.closeMenu}>
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to={'/profile'}>
                  <ListItemIcon>
                    <Icon>account_circle</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={user ? user.username : ''}
                    classes={{ text: classes.primaryText }}
                  />
                </MenuItem>
                <Divider />
                <MenuItem onClick={this.closeMenu} component={Link} to={'/add'}>
                  <ListItemIcon>
                    <Icon>note_add</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Nuovo oggetto"
                  />
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to={'/me/items/owned'}>
                  <ListItemIcon>
                    <Icon>playlist_add_check</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Lista possiedo"
                  />
                </MenuItem>
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to={'/me/items/wanted'}>
                  <ListItemIcon>
                    <Icon>playlist_add_check</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Lista voglio"
                  />
                </MenuItem>
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to={'/me/items/can-get'}>
                  <ListItemIcon>
                    <Icon>playlist_play</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Posso avere"
                  />
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to={'/me/swaps'}>
                  <ListItemIcon>
                    <Icon>autorenew</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Proposte"
                  />
                </MenuItem>
                <MenuItem
                  onClick={this.closeMenu}
                  component={Link}
                  to="https://about.swapick.com/come-funziona"
                  target="_blank"
                >
                  <ListItemIcon>
                    <Icon>monetization_on</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="eCoin"
                  />
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() => {
                    this.closeMenu()
                    logout()
                  }}>
                  <ListItemIcon>
                    <Icon>exit_to_app</Icon>
                  </ListItemIcon>
                  <ListItemText
                    classes={{ text: classes.menuText }}
                    primary="Logout"
                  />
                </MenuItem>
              </Menu>
            </div>
          )}
        </div>
      </Toolbar>
    )
  }
}

const mapStateToProps = state => {
  const config = getTopBarConfig(state)
  return {
    expandable: config.expandable,
    topSearch: config.topSearch,
    expanded: state.ui.topBarExpanded,
    user: state.auth.user,
    showAuthControls: state.auth.authenticatingWithToken || state.auth.user,
  }
}

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, {
      logout,
      uiCollapseTopBar,
      uiExpandTopBar,
    })(MainToolbarDesktop)
  )
)



// WEBPACK FOOTER //
// ./src/common/TopBar/MainToolbarDesktop.js